export const COLUMNS_LIMIT_DEFAULT = 4;
export const COLUMNS_LIMIT_SPORT = Infinity;
export const COLUMNS_LIMIT_ASSETS = 3;
export const MIN_ROWS_NUMBER_FOR_SORTING = 6;
export const ROWS_LIMIT = 10;
